import { createAction } from '@wix/communities-blog-client-common';

export const POST_PAGE_MORE_BUTTON_CLICKED = 'postPageMoreButton/CLICKED';

export const postPageMoreButtonClicked = createAction(
  POST_PAGE_MORE_BUTTON_CLICKED,
);
